import Button from './button'

export const AmuiButton = Button

export default Vue => Vue.component(Button.name, Button)
